export default {

  required: {
    message : "Please enter email address.",
    fn      : (input)=> input.length,
  },

  format: {
    message : "Please enter proper email.",
    fn      : (input)=> Boolean(input.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/))
  }
}
